module.exports = __webpack_public_path__ + "static/media/accenture.2a265dc8.svg";